import { ItiBaseDto } from '@/iti-core-vue';

export class UnitType extends ItiBaseDto {
    public code !: string;
    public description !: string;
}